import { Dispatch, useState } from "react";
import { TypeBankInfo } from "~/typings/types";
import { clientApi, cleanText } from "~/utils";
import { ErrorRequest } from "../FormFieldAutocompleteBic";

export const useGetBankInfo = (setErrorGetSuggestions: Dispatch<ErrorRequest>, url: string) => {
  const [suggestions, setSuggestions] = useState<TypeBankInfo[]>([]);
  const [isPendingResponseSuggestions, setIsPendingResponseSuggestions] = useState(false);

  const fetchSuggestions = async (query: string) => {
    try {
      setIsPendingResponseSuggestions(true);
      setErrorGetSuggestions(null);

      const response = await clientApi.get(`${url}?keyword=${cleanText(query)}`);
      setSuggestions(response?.data?.data);
    } catch (error: any) {
      setErrorGetSuggestions(error?.response?.data?.error?.[0]);
    } finally {
      setIsPendingResponseSuggestions(false);
    }
  };

  return {
    suggestions,
    setSuggestions,
    isPendingResponseSuggestions,
    fetchSuggestions
  };
};
